export const PaymentMethodTypes = [
	{
		id: 1,
		description: 'Check',
		shortDescription: 'Check'
	},
	{
		id: 2,
		description: 'Credit Card',
		shortDescription: 'CC'
	},
	{
		id: 3,
		description: 'EFT',
		shortDescription: 'EFT'
	},
	{
		id: 4,
		description: 'Cash',
		shortDescription: 'Cash'
	}
];
